var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ts-page-layout',{attrs:{"center":""}},[_c('ts-div-guide-page',{staticStyle:{"margin-top":"20px"},attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }